import { Navigate } from 'react-router-dom'
import { Card } from '@/components/ui/Card'
import { SkeletonRows } from '@/components/ui/States'
import { useAuth } from '@/auth/useAuth'

/**
 * Where Auth0 returns to. It renders for the few hundred milliseconds the token
 * exchange takes and then gets replaced — `onRedirectCallback` navigates to the
 * stored `returnTo`, so nothing here decides the destination.
 *
 * It exists because this path has to resolve to something: without a route,
 * `/callback` falls through to NotFoundPage behind RequireAuth, which bounces
 * back to /login and loses the authorization code in the URL.
 *
 * The `error` case is the one that matters. A sign-in the Auth0 Action denied
 * returns here with no session, and sending the user back to /login is what puts
 * the failure in front of them rather than leaving them on a spinner.
 */
export function CallbackPage() {
  const { loading, error } = useAuth()

  if (!loading && error) return <Navigate to="/login" replace />

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-canvas px-6">
      <Card className="w-full max-w-[380px]">
        <div className="space-y-3 p-6">
          <p className="text-[13px] leading-5 text-ink-muted">Finishing sign-in…</p>
          <SkeletonRows rows={2} />
        </div>
      </Card>
    </div>
  )
}
